
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cricket-players",
      function () {
        return require("private-next-pages/cricket-players/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cricket-players"])
      });
    }
  